<template lang="pug">
#bloco-inserir-dados-contrato-originacao-manual
    div(v-if='dados.isSubproduto')
        h1 {{ $t(`mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.informarPlantaFabril`) }}
        el-card
            .dados-contrato-originacao-manual__row
                .dados-contrato-originacao-manual__field
                    label.dados-contrato-originacao-manual__field-label.obrigatorio {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.plantaFabril') }}
                    el-select(
                        v-model='plantaFabrilId'
                        filterable,
                        value-key='id',
                        :placeholder="$t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.plantaFabrilPlaceholder')"
                        @change='selecionarPlantaFabril()'
                    )
                        el-option(
                            v-for='plantaFabril in plantasFabril',
                            :key='plantaFabril.id',
                            :label='plantaFabril.nome',
                            :value='plantaFabril.id'
                        ) {{ plantaFabril.nome }}

                .bloco-dados-contrato-originacao-informacao
                    h4 {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.carsComSaldoDisponivel') }}
                    p.cars-disponivel-label(
                        :class='{"cars-indisponivel-label": !carsDisponiveis?.length}'
                        @click='showModalCarsDisponiveis = !!carsDisponiveis?.length'
                    ) {{ carsDisponiveisLabel }}
                .bloco-dados-contrato-originacao-informacao
                    h4 {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.materialOrigem') }}
                    p {{ materialOrigemExibicao?.nome || '-' }}
                .bloco-dados-contrato-originacao-informacao
                    h4 {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.volumeMaterialOrigem') }}
                    p {{ materialOrigemExibicao?.volume || '-' }}
                .bloco-dados-contrato-originacao-informacao
                    h4 {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.percentualProducao') }}
                    p {{ materialOrigemExibicao?.percentual ? `${materialOrigemExibicao.percentual}%` : '-' }}
    div
        h1 {{ $t(`mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.titulo`) }}
        el-card
            .box-card-inserir-dados-manual
                .box-card-inserir-dados-manual__conteudo
                    .box-card-inserir-dados-manual__conteudo__bloco
                        span {{ $t(`mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.texto`) }}

                    el-alert(type='info', show-icon, :closable='false')
                        | {{ $t(`mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.pesquisaPorDocumento`) }}

                    .box-card-inserir-dados-manual__conteudo__bloco
                        el-form.box-card-inserir-dados-manual__conteudo__bloco_pesquisa(
                            label-position='top',
                            :model='formularioCadastroTerritorio',
                            :rules='this.usuarioLogado.isBunge ? formularioCadastroTerritorioRegrasBunge : formularioCadastroTerritorioRegrasRevenda',
                            ref='formularioCadastroTerritorio'
                        )
                            .box-card-inserir-dados-manual__conteudo__bloco_pesquisa-por-territorio.width-direito
                                el-form-item(:prop='computedPropCpfCpnj')
                                    template(slot='label')
                                        span {{ $t(`mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.pesquisaDocumento`) }}
                                        el-tooltip(
                                            :content='$t(`mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.documentoProdutor`)',
                                            placement='top'
                                        )
                                            i.el-icon-info.dados-manual

                                    .input-pesquisa-por-territorio.input-car-cpf-cnpj
                                        el-select(
                                            v-model='formularioCadastroTerritorio.cpfCnpj',
                                            value-key='cpfCnpj',
                                            :loading='buscandoRepresentante',
                                            :loading-text='textoBuscandoRepresentante',
                                            filterable,
                                            remote,
                                            clearable,
                                            @clear='limparCPF',
                                            reserve-keyword,
                                            :placeholder='$t(`mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.buscaPorDocumento`)',
                                            remote-show-suffix,
                                            ref='selectCpfCnpj',
                                            :remote-method='buscarRepresentanteNomeOuCpfCnpj',
                                            :disabled='loadingResumo'
                                        )
                                            el-option(
                                                v-for='representante in representantes',
                                                :key='representante.id',
                                                :label='representante.cpfCnpj',
                                                :value='representante.cpfCnpj'
                                            )
                                                .input-pesquisa-por-representante-select
                                                    span {{ representante.nomeRazaoSocial }}
                                                    span.direita {{ 'Documento: ' + representante.cpfCnpj + '' }}

                                        el-button(
                                            type='primary',
                                            @click.prevent='buscarTerritoriosVinculados'
                                        ) {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.buscar') }}

                            .box-card-inserir-dados-manual__conteudo__bloco_pesquisa-por-territorio.width-direito
                                el-form-item(prop='territorioSelecionado')
                                    template(slot='label')
                                        span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.pesquiseCar') }}
                                        el-tooltip(
                                            :content='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.informeCar")',
                                            placement='top'
                                        )
                                            i.el-icon-info.dados-manual

                                    .input-pesquisa-por-territorio
                                        el-select(
                                            v-model='formularioCadastroTerritorio.territorioSelecionado',
                                            value-key='idTerritorio',
                                            :loading='buscandoTerritorio',
                                            :loading-text='textoBuscandoTerritorio',
                                            filterable,
                                            remote,
                                            clearable,
                                            @clear='limparTerritorios',
                                            reserve-keyword,
                                            :placeholder='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.pesquiseCar")',
                                            remote-show-suffix,
                                            ref='selectCarTerritorio',
                                            :remote-method='handleCarInput',
                                            :disabled='loadingResumo'
                                        )
                                            el-option(
                                                v-for='territorio in territorios',
                                                :key='territorio.idTerritorio',
                                                :label='territorio.codigoCar',
                                                :value='territorio'
                                            )
                                                .input-pesquisa-por-territorio-select
                                                    span {{ territorio.nomeTerritorio }}
                                                    span.direita {{ 'CAR: ' + territorio.codigoCar + '' }}

                                            template(
                                                v-if='inputValue.length >= 5 && !territorios.length && !buscandoTerritorio',
                                                #empty
                                            )
                                                .inserir-dados-manual-sem-resultado(
                                                    v-if='!verificarCar(inputValue)'
                                                )
                                                    p {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.nenhumResultado') }}

                                                .inserir-dados-manual-sem-resultado-cadastro-car(
                                                    v-else
                                                )

                            .box-card-inserir-dados-manual__conteudo__bloco__buttons
                                el-button(
                                    ref='btnValidarTerritorio',
                                    type='primary',
                                    icon='el-icon-search',
                                    @click.prevent='validarTerritorioResumo',
                                    :disabled='loadingResumo'
                                ) {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.analisarElegibilidade') }}

                    transition(name='el-fade-in')
                        .box-card-inserir-dados-manual__conteudo__bloco(
                            v-if='showResumoElegibilidade'
                        )
                            .box-card-inserir-dados-manual__conteudo__bloco__elegibilidade.width-direito
                                .cabecalho-resumo-elegibilidade
                                    .analise-elegibilidade-codigo-car
                                        span CAR:
                                        span.car-codigo {{ formularioCadastroTerritorio.territorioSelecionado?.codigoCar || formularioCadastroTerritorio.territorioSelecionado }}
                                    .analise-elegibilidade-span
                                        span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.analiseDeElegibilidade') }}
                                        .analise-elegibilidade-span__resultado(
                                            v-if='resultadoElegibilidade !== "INDEFINIDO"'
                                        )
                                            i.flow.flow-warning-sign(
                                                :class='corStatus[resultadoElegibilidade].classeCor'
                                            )
                                            span(
                                                :class='corStatus[resultadoElegibilidade].classeCor'
                                            ) {{ corStatus[resultadoElegibilidade].status }}
                                        .analise-elegibilidade-span__resultado(
                                            v-else
                                        ) -

                                #resumoDiv.resumo-elegibilidade(
                                    :style='{ "background-color": corStatus[resultadoElegibilidade]?.background || "" }'
                                )
                                    .resumo-elegibilidade__diagnostico.resumo-elegibilidade-item
                                        |
                                        span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.diagnosticoSocioambiental') }}
                                        SkeletonBlocoResumoAnalise.resumo-elegibilidade__diagnostico--item(
                                            :carregando='loadingResumo'
                                        )
                                            span(
                                                v-if='dadosAnaliseElegibilidade.dadosDiagnostico.resultadoDiagnosticoRastreabilidade === null'
                                            )
                                                | -
                                            span(
                                                v-else,
                                                :class='statusDiagnostico[dadosAnaliseElegibilidade.dadosDiagnostico.nivelAlertaRastreabilidade].corClasse'
                                            ) {{ statusDiagnostico[dadosAnaliseElegibilidade.dadosDiagnostico.nivelAlertaRastreabilidade].status }}
                                    .resumo-elegibilidade__saldo.resumo-elegibilidade-item
                                        span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.saldoDisponivel') }}
                                        SkeletonBlocoResumoAnalise.resumo-elegibilidade__saldo--item(
                                            :carregando='loadingResumo'
                                        )
                                            span(
                                                v-if='dadosAnaliseElegibilidade.dadosBuscaSaldo.saldoCARcapacidadeProdutiva === null && dadosAnaliseElegibilidade.dadosBuscaSaldo.capacidadeProdutiva === null'
                                            )
                                                | -
                                            span(
                                                v-else,
                                                :class='dadosAnaliseElegibilidade.dadosBuscaSaldo.saldoCARcapacidadeProdutiva <= 0 ? "status-danger" : "status-sucess"'
                                            ) {{ dadosAnaliseElegibilidade.dadosBuscaSaldo.saldoCARcapacidadeProdutiva.toFixed(2) }} ({{ dadosAnaliseElegibilidade.dadosBuscaSaldo.calculoSaca.saldoCARcapacidadeProdutivaSaca }} sc)

                                    .resumo-elegibilidade__distancia.resumo-elegibilidade-item
                                        |
                                        span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.distancia') }}
                                        SkeletonBlocoResumoAnalise.resumo-elegibilidade__distancia--item(
                                            :carregando='loadingResumo'
                                        )
                                            span(
                                                v-if='dadosAnaliseElegibilidade.dadosCalculoRaio.distanciaRaioMunicipioECar === null'
                                            )
                                                | -
                                            span(
                                                v-else,
                                                :class='dadosAnaliseElegibilidade.dadosCalculoRaio.distanciaPermitida > 0 ? classAnaliseDistancia : "status-sucess"'
                                            ) {{ dadosAnaliseElegibilidade.dadosCalculoRaio.distanciaRaioMunicipioECar }} km

                                    .resumo-elegibilidade__link-detalhar.resumo-elegibilidade-item(
                                        v-if='dadosAnaliseElegibilidade.dadosDiagnostico.nivelAlertaRastreabilidade !== null && dadosAnaliseElegibilidade.dadosBuscaSaldo.capacidadeProdutiva !== null',
                                        @click.prevent='modalAnaliseElegibilidade'
                                    )
                                        span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.verDetalhes') }}
                                        i.mdi.mdi-arrow-right
                                    .resumo-elegibilidade__link-detalhar(v-else)

                            .box-card-inserir-dados-manual__conteudo__bloco__volume
                                el-form(
                                    label-position='top',
                                    :model='formularioCadastroTerritorio',
                                    :rules='formularioCadastroTerritorioRegrasVolume',
                                    ref='formularioCadastroTerritorioVolume',
                                    @submit.native.prevent
                                )
                                    .box-card-inserir-dados-manual__conteudo__bloco_pesquisa-por-volume.width-esquerdo
                                    el-form-item(prop='volumeTerritorio')
                                        template(slot='label')
                                            span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.volume') }}

                                        el-input(
                                            :placeholder='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.inserirVolume")',
                                            v-model='formularioCadastroTerritorio.volumeTerritorio',
                                            @blur='volumeRecebidoFormatado',
                                            :disabled='loadingResumo'
                                        )

                            .box-card-inserir-dados-manual__conteudo__bloco__buttons.width-esquerdo
                                el-button(
                                    type='primary',
                                    icon='el-icon-plus',
                                    :disabled='resultadoElegibilidade === "INDEFINIDO"',
                                    :loading='territorioSendoInserido',
                                    @click.prevent='validarTerritorioManual'
                                ) {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.adicionarLista') }}

        ModalCarsDisponiveis(
            :show='showModalCarsDisponiveis',
            @fechar='showModalCarsDisponiveis = false',
            :propriedadesSaldos='carsDisponiveis'
        )

        ModalCadastrarTerritorioManual(
            :mostrar='showModalCadastroTerritorio',
            @fechar='showModalCadastroTerritorio = false',
            @territorio-cadastrado='definirVolumeTerritorioCadastrado'
        )

        ModalAnaliseElegibilidadeResumo(
            :show='ativarModalAnaliseElegibilidade',
            :dados='dadosAnaliseElegibilidade',
            @handleCloseModalAnaliseElegibidade='ativarModalAnaliseElegibilidade = false'
        )

        .modal-definir-volume(v-if='showModalDadosCadastroManual')
            ModalDadosCadastroManual(
                :mostrar='showModalDadosCadastroManual',
                @fechar='showModalDadosCadastroManual = false',
                :territorio='territorioCadastrado',
                @definir-volume='definirVolume'
            )
        .modal-selecionar-cars-cpf-cnp
            ModalSelecionarCarsCpfCnp(
                :show='mostrarModalDadosCarsCpfCnp',
                :cpfCnpj='formularioCadastroTerritorio.cpfCnpj',
                :dados='dadosCarsCpfCnp',
                @voltar='mostrarModalDadosCarsCpfCnp = false',
                @retornarDadosSelecionados='exibirDadosCarsCpfCnp'
            )
    .modal-media-capacidade-produtiva(v-if='showModalDadosCapacidadeProdutiva')
        el-dialog(
            :visible.sync='showModalDadosCapacidadeProdutiva',
            :close-on-click-modal='false'
        )
            template(slot='title')
                .modal-media-capacidade-produtiva__title
                    i.el-icon-error
                    span {{ dadosMediaCapacidadeProdutivaRegional.title }}

            p {{ dadosMediaCapacidadeProdutivaRegional.message }}

            .modal-media-capacidade-produtiva__linha
                .modal-media-capacidade-produtiva__coluna
                    span.modal-media-capacidade-produtiva__label {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.territorio') }}
                    p {{ dadosMediaCapacidadeProdutivaRegional.territorioNome }}
                .modal-media-capacidade-produtiva__coluna
                    span.modal-media-capacidade-produtiva__label {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.area') }}
                    p {{ dadosMediaCapacidadeProdutivaRegional.territorioArea }}
            .modal-media-capacidade-produtiva__linha
                .modal-media-capacidade-produtiva__coluna
                    span.modal-media-capacidade-produtiva__label {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.volumeMax') }}
                    p.modal-media-capacidade-produtiva__permitido {{ dadosMediaCapacidadeProdutivaRegional.volumeMaximoPermitido }}
                .modal-media-capacidade-produtiva__coluna
                    span.modal-media-capacidade-produtiva__label {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.volumeAdc') }}
                    p.modal-media-capacidade-produtiva__excedente {{ formularioCadastroTerritorio.volumeTerritorio + ' t' }}

            hr

            el-table(
                :data='dadosMediaCapacidadeProdutivaRegional.medias',
                style='width: 100%'
            )
                el-table-column(
                    prop='estadoNome',
                    label='Estado',
                    align='center',
                    width='100'
                )
                el-table-column(prop='mediaRegionalPorUnidade', align='center')
                    template(slot='header', slot-scope='scope')
                        el-tooltip(
                            :content='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.fonte") + dadosMediaCapacidadeProdutivaRegional.fonte',
                            placement='top'
                        )
                            i.el-icon-info.modal-media-capacidade-produtiva__info
                        span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.mediaRegional') }}
                el-table-column(
                    prop='mediaPermitidaPorUnidade',
                    label='Média permitida',
                    align='center'
                )
                    template(slot='header', slot-scope='scope')
                        el-tooltip(
                            :content='dadosMediaCapacidadeProdutivaRegional.mediaPermitidaPorUnidadeTooltip',
                            placement='top'
                        )
                            i.el-icon-info.modal-media-capacidade-produtiva__info
                        span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.maxPermitido') }}
                el-table-column(
                    prop='mediaTerritorioPorUnidade',
                    align='center'
                )
                    template(slot='header', slot-scope='scope')
                        el-tooltip(
                            :content='dadosMediaCapacidadeProdutivaRegional.mediaTerritorioPorUnidadeTooltip',
                            placement='top'
                        )
                            i.el-icon-info.modal-media-capacidade-produtiva__info
                        span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.mediaVolumeInserido') }}
                el-table-column(align='center')
                    template(slot='header', slot-scope='scope')
                        el-tooltip(
                            :content='dadosMediaCapacidadeProdutivaRegional.excedentePorUnidadeTooltip',
                            placement='top'
                        )
                            i.el-icon-info.modal-media-capacidade-produtiva__info
                        span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.ExcedenteMaximo') }}
                    template(slot-scope='scope')
                        div
                            span.modal-media-capacidade-produtiva__excedente {{ scope.row.excedentePorUnidade }}
            span.dialog-footer(slot='footer')
                el-button(
                    type='primary',
                    @click='showModalDadosCapacidadeProdutiva = false'
                ) Ok
</template>

<script>
import ModalDadosCadastroManual from '@/components/contratosOriginacao/SubEmpresaModalRevisarTerritorio.vue';
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
import ModalCadastrarTerritorioManual from '@/components/contratosOriginacao/SubEmpresaModalCadastrarTerritorio.vue';
import ModalSelecionarCarsCpfCnp from '@/components/contratosOriginacao/ModalSelecionarCarsCpfCnpj.vue';
import ModalCarsDisponiveis from '@/components/contratosOriginacao/ModalCarsDisponiveis.vue';
import CarUtils from '@/utils/CarUtils';
import formatters from '@/utils/formatters';
import SkeletonBlocoResumoAnalise from '@/components/contratosOriginacao/SkeletonBlocoResumoAnaliseEligibilidade.vue';
import ModalAnaliseElegibilidadeResumo from '@/components/contratosOriginacao/ModalAnaliseElegibilidadeResumo.vue';
import validators from '@/utils/validations/validators';
import CarService from '@/services/car/CarService';
import RepresentanteService from '@/services/RepresentanteService';
import { mapGetters } from 'vuex';
import debounce from 'lodash/debounce';
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';

export default {
    name: 'SubEmpresaBlocoInserirDadosContratoManualmente',
    components: {
        ModalCadastrarTerritorioManual,
        ModalDadosCadastroManual,
        SkeletonBlocoResumoAnalise,
        ModalAnaliseElegibilidadeResumo,
        ModalSelecionarCarsCpfCnp,
        ModalCarsDisponiveis,
        validators
    },
    props: {
        dadosEdicaoVolume: {
            type: Object,
            required: true,
            default: () => ({})
        },
        volumeDisponivelContrato: {
            type: Number,
            required: true
        },
        dados: {
            type: Object,
            required: true
        },
        isRastreabilidadeOffline: {
            type: Boolean,
            required: true
        }
    },

    data() {
        const validarVolume = (rule, value, callback) => {
            if (value === '') {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.campoObrigatorio'
                        )
                    )
                );
                return;
            }

            if (value.toString().includes('.')) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.somenteNumero'
                        )
                    )
                );
                return;
            }

            const maisVirgulas = /.*,.*,.*/;
            if (
                maisVirgulas.test(value) ||
                value.toString().startsWith(',') ||
                value.toString().startsWith(',')
            ) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.ErroFormatacao'
                        )
                    )
                );
                return;
            }

            if (parseFloat(value.toString().replace(',', '.')) <= 0) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.maiorQueZero'
                        )
                    )
                );
                return;
            }

            if (this.formularioCadastroTerritorio?.territorioSelecionado) {
                const selectedCar =
                    this.formularioCadastroTerritorio.territorioSelecionado;
                const blocked = this.dados.blocks
                    .filter(
                        block =>
                            block.codigoCar ===
                            (selectedCar?.codigoCar || selectedCar)
                    )
                    .pop();
                const carVolume = Number.parseFloat(
                    this.formularioCadastroTerritorio.volumeTerritorio
                );
                if (blocked && blocked.volume > carVolume) {
                    callback(
                        new Error(
                            this.$t(
                                'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.menorQueBloqueioMinimo',
                                [blocked.volume]
                            )
                        )
                    );
                }
            }

            callback();
        };

        return {
            formularioCadastroTerritorio: {
                volumeTerritorio: '',
                territorioSelecionado: '',
                cpfCnpj: ''
            },
            formularioCadastroTerritorioRegrasRevenda: {
                territorioSelecionado: [
                    {
                        required: true,
                        validator: this.checkRuleCAR,
                        trigger: 'change'
                    }
                ],
                cpfCnpj: [
                    {
                        required: true,
                        validator: this.checkRuleCpfCnpj,
                        trigger: 'change'
                    }
                ]
            },
            formularioCadastroTerritorioRegrasBunge: {
                territorioSelecionado: [
                    {
                        required: true,
                        validator: this.checkRuleCAR,
                        trigger: 'change'
                    }
                ],
                cpfCnpj: [
                    {
                        required: false,
                        validator: this.checkRuleCpfCnpj,
                        trigger: 'change'
                    }
                ]
            },
            formularioCadastroTerritorioRegrasVolume: {
                volumeTerritorio: [
                    {
                        required: true,
                        validator: validarVolume,
                        trigger: 'blur'
                    }
                ]
            },
            showModalCarsDisponiveis: false,
            materialOrigem: [],
            plantasFabril: [],
            plantaFabrilId: null,
            carsDisponiveis: [],
            territorios: [],
            representantes: [],
            numeroContrato: this.$route.params.numeroContrato,
            showModalCadastroTerritorio: false,
            showModalDadosCadastroManual: false,
            territorioCadastrado: {},
            buscandoTerritorio: true,
            buscandoRepresentante: true,
            inputValue: '',
            debouncedFetchTerritorios: debounce(this.fetchTerritorios, 500),
            inputValueRepresentante: '',
            textoBuscandoTerritorio: this.$t(
                'mensagens.comuns.digiteNoMinimo3CaracteresParaPesquisar'
            ),
            textoBuscandoRepresentante: this.$t(
                'mensagens.comuns.digiteNoMinimo3CaracteresParaPesquisar'
            ),
            showModalDadosCapacidadeProdutiva: false,
            dadosMediaCapacidadeProdutivaRegional: {
                medias: []
            },
            dadosTerritorioListagem: {
                cars: [],
                idTerritorio: null,
                mensagemCadastroSucesso: '',
                nomeTerritorio: '',
                numeroCar: null,
                numeroContrato: '',
                volume: null
            },
            corStatus: {
                ELEGIVEL: {
                    classeCor: 'status-sucess',
                    background: '#3591381A',
                    status: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.elegivel'
                    )
                },
                INELEGIVEL: {
                    classeCor: 'status-danger',
                    background: '#EC32321A',
                    status: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.inelegivel'
                    )
                },
                INDEFINIDO: {
                    classeCor: '',
                    status: ''
                },
                ALERTA: {
                    classeCor: 'status-laranja',
                    background: '#F9935A1A',
                    status: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.comAlerta'
                    )
                }
            },
            statusDiagnostico: {
                MEDIO_ALTO: {
                    corClasse: 'status-laranja',
                    status: 'Alerta'
                },
                MEDIO: {
                    corClasse: 'status-amarelo',
                    status: 'Alerta'
                },
                BAIXO: {
                    corClasse: 'status-sucess',
                    status: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.elegivel'
                    )
                },
                ALTO: {
                    corClasse: 'status-danger',
                    status: 'Inconforme'
                }
            },
            resultadoElegibilidade: 'INDEFINIDO',
            dadosAnaliseElegibilidade: {
                elegibilidade: '',
                valor: '',
                cpfCnpj: '',
                safraNome: '',
                dadosDiagnostico: {
                    diagnosticoRepresentante: [],
                    diagnosticoCar: null,
                    resultadoDiagnosticoRastreabilidade: null,
                    nivelAlertaRastreabilidade: null
                },
                dadosCalculoRaio: {
                    distanciaRaioMunicipioECar: null,
                    possuiIntersecao: null,
                    siglaEstadoContrato: null
                },
                dadosRestricaoEstado: {
                    possuiRestricaoEstado: null,
                    siglaEstadoCar: null,
                    siglaEstadoPermitido: null,
                    aplicarTodoEstado: null
                },
                dadosRestricaoMunicipio: {
                    possuiRestricaoMunicipio: null,
                    municipioCar: null,
                    municipioPermitido: null
                },
                dadosBuscaSaldo: {
                    id: null,
                    codigoCar: '',
                    capacidadeProdutiva: null,
                    saldoCARcapacidadeProdutiva: null,
                    calculoSaca: {
                        saldoCARcapacidadeProdutivaSaca: null,
                        saldoCarComprometido: null
                    },
                    cultura: {
                        id: null,
                        nome: '',
                        codigo: ''
                    },
                    anoSafra: {
                        id: null,
                        ano: null,
                        tipoSafra: '',
                        descricao: ''
                    },
                    criadoEm: null,
                    saldoCarComprometido: null
                }
            },
            bloquearInput: false,
            loadingResumo: false,
            ativarModalAnaliseElegibilidade: false,
            territorioSendoInserido: false,
            mostrarModalDadosCarsCpfCnp: false,
            mostrarModalDadosTerritorioPy: false,
            dadosCarsCpfCnp: [],
            dadosTerritorioPy: [],
            showResumoElegibilidade: false,
            carVeioViaEdicao: false,
            materialOrigemSelecionado: null
        };
    },

    watch: {
        isSubproduto(value) {
            if (value) {
                this.obterListaPlantasFabril();
            }
        },
        'formularioCadastroTerritorio.territorioSelecionado': function (
            newVal,
            oldVal
        ) {
            this.showResumoElegibilidade = false;
        },

        'formularioCadastroTerritorio.cpfCnpj': function (newVal, oldVal) {
            this.showResumoElegibilidade = false;
        },
        dadosEdicaoVolume: async function (newVal, oldVal) {
            if (newVal) {
                this.formularioCadastroTerritorio.territorioSelecionado =
                    newVal.resumoDiagnosticoTerritorio.imovel.codigo;
                this.formularioCadastroTerritorio.cpfCnpj = newVal
                    .territorioRepresentantes.length
                    ? newVal.territorioRepresentantes[0].cpfCnpj
                    : '';
                this.callAnaliseResumo();
            }
        }
    },

    computed: {
        ...mapGetters(['usuarioLogado']),
        materialOrigemExibicao() {
            return this?.materialOrigemSelecionado || this.dados?.materialOrigem || {};
        },
        isSubproduto() {
            return this.dados?.isSubproduto || false;
        },
        carsDisponiveisLabel() {
            return this.carsDisponiveis?.length
                ? this.$t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.verListagem')
                : this.$t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.naoHaCars');
        },
        cpfCnpjValido() {
            if (this.formularioCadastroTerritorio.cpfCnpj) {
                return validators.validarDocumento(
                    this.formularioCadastroTerritorio.cpfCnpj
                );
            }

            return false;
        },
        computedPropCpfCpnj() {
            return !this.isRastreabilidadeOffline ? 'cpfCnpj' : '';
        },
        classAnaliseDistancia() {
            return this.dadosAnaliseElegibilidade.dadosCalculoRaio
                .distanciaRaioMunicipioECar &&
                this.dadosAnaliseElegibilidade.dadosCalculoRaio
                    .distanciaRaioMunicipioECar >
                this.dadosAnaliseElegibilidade.dadosCalculoRaio
                    .distanciaPermitida
                ? 'status-danger'
                : 'status-sucess';
        }
    },
    methods: {
        async obterListaPlantasFabril() {
            try {
                const numeroContrato = this.$route.params.numeroContrato || '';
                const response = await ContratoOriginacaoService.buscarListaPlantaFabril(numeroContrato);

                this.carsDisponiveis = this.dados?.propriedadesSaldos || [];
                this.plantasFabril = response?.data;
                if (this.dados.plantaFabrilId) {
                    this.plantaFabrilId = this.dados.plantaFabrilId;
                }
            } catch {
                this.$notify.error(
                    this.$t(
                        'mensagens.configuracaoRastreabilidade.plantasFabril.erroObter'
                    )
                );
            }
        },

        async selecionarPlantaFabril() {
            try {
                const numeroContrato = this.$route.params.numeroContrato || '';
                const plantaId = this.plantaFabrilId;
                const { data } = await ContratoOriginacaoService.selecionarPlantaFabril(numeroContrato, plantaId);

                this.carsDisponiveis = data?.propriedadesSaldos || [];
                this.materialOrigemSelecionado = data.materialOrigem;
                this.$notify.success(
                    'Planta fabril selecionada com sucesso'
                );

            } catch (error) {
                this.$notify.error('Erro ao selecionar planta fabril');
            }

        },

        callAnaliseResumo() {
            setTimeout(() => {
                this.realizarResumo();
            }, 1000);
        },
        aplicarMascaraCar(valor) {
            let limpo = valor.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

            limpo = limpo.slice(0, 41);

            let resultado = '';

            for (let i = 0; i < limpo.length; i++) {
                if (i === 2 || i === 9) {
                    resultado += '-';
                }
                resultado += limpo[i];
            }

            return resultado;
        },
        handleCarInput(filtro) {
            const selectRef = this.$refs.selectCarTerritorio;
            if (selectRef && selectRef.$el) {
                const inputEl = selectRef.$el.querySelector('input');
                if (inputEl) {
                    const valorMascarado = this.aplicarMascaraCar(filtro);
                    this.$nextTick(() => {
                        inputEl.value = valorMascarado;
                    });
                    this.debouncedFetchTerritorios(valorMascarado);
                    return;
                }
            }
            this.debouncedFetchTerritorios(filtro);
        },
        async fetchTerritorios(filtro) {
            this.limparTerritorios();
            this.buscandoTerritorio = true;

            if (filtro.length < 5) {
                this.textoBuscandoTerritorio = this.$t(
                    'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.min'
                );
                this.territorios = [];
                this.inputValue = this.$t(
                    'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.max'
                );
                return;
            }

            if (filtro.length > 43) {
                this.textoBuscandoTerritorio = '';
                this.territorios = [];
                this.inputValue = '';
                return;
            }

            this.textoBuscandoTerritorio = this.$t(
                'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.carregando'
            );
            this.inputValue = filtro;
            try {
                this.buscandoTerritorio = true;
                const { data } =
                    await ContratoOriginacaoServiceSubEmpresa.buscarTerritorioFiltro(
                        filtro
                    );
                if (CarUtils.isCar(filtro) && !data.length) {
                    this.formularioCadastroTerritorio.territorioSelecionado =
                        CarUtils.addMascaraCar(filtro);
                    this.inputValue = filtro;
                    this.buscandoTerritorio = false;
                } else {
                    this.territorios = data;
                }
                this.buscandoTerritorio = false;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.erroBuscarDados'
                    )
                });
            }
        },
        validarTerritorioManual() {
            // let volumeTerritorio = parseFloat(
            //     this.formularioCadastroTerritorio.volumeTerritorio.replace(
            //         ',',
            //         '.'
            //     )
            // );

            // if (volumeTerritorio > this.volumeDisponivelContrato) {
            //     this.$notify.error({
            //         message:
            //             'O volume a ser inserido excede o volume disponível do contrato.'
            //     });
            //     return;
            // }

            let temErroForm = false;
            this.$refs['formularioCadastroTerritorioVolume'].validate(valid => {
                if (!valid) {
                    temErroForm = true;
                }
            });

            this.$refs['formularioCadastroTerritorio'].validate(valid => {
                if (!valid) {
                    temErroForm = true;
                }
            });

            if (!temErroForm) {
                this.adicionarTerritorioListagem();
            }
        },
        async adicionarTerritorioListagem() {
            this.territorioSendoInserido = true;

            try {
                const contrato = {
                    idTerritorio: this.formularioCadastroTerritorio
                        .territorioSelecionado?.idTerritorio
                        ? this.formularioCadastroTerritorio
                            .territorioSelecionado.idTerritorio
                        : '',
                    numeroContrato: this.numeroContrato,
                    volume: parseFloat(
                        this.formularioCadastroTerritorio.volumeTerritorio.replace(
                            ',',
                            '.'
                        )
                    ),
                    numeroCar: this.formularioCadastroTerritorio
                        .territorioSelecionado.codigoCar
                        ? this.formularioCadastroTerritorio
                            .territorioSelecionado.codigoCar
                        : this.formularioCadastroTerritorio
                            .territorioSelecionado,
                    cpfCnpj: this.formularioCadastroTerritorio.cpfCnpj,
                    idFonte:
                        this.dadosAnaliseElegibilidade.dadosBuscaSaldo
                            .fonteDados.id
                };

                const response =
                    await ContratoOriginacaoServiceSubEmpresa.inserirDadosContrato(
                        contrato
                    );

                this.$notify.success({
                    message: response.data.mensagemCadastroSucesso
                });

                this.$emit('atualizarListaPosInserir');

                this.$refs['formularioCadastroTerritorio'].resetFields();
                this.$refs['formularioCadastroTerritorioVolume'].resetFields();
                this.territorios = [];
                this.showResumoElegibilidade = false;
            } catch (error) {
                this.exibirNotificacoesErros(error);
            } finally {
                this.territorioSendoInserido = false;
            }
        },

        exibirNotificacoesErros(error) {
            if (error.response.data.type === 'MEDIA_CAPACIDADE_REGIONAL') {
                this.exibirDadosCapacidadeMediaRegional(error);
            } else if (error.response.data.type === 'FORA_DO_RAIO_PERMITIDO') {
                this.$messageBox.alert(
                    error.response.data.message,
                    error.response.data.title,
                    {
                        confirmButtonText: 'Voltar',
                        type: 'warning'
                    }
                );
            } else {
                this.$notify.error({
                    message: error.response.data.message
                });
            }
        },

        exibirDadosCapacidadeMediaRegional(error) {
            const {
                estadoNome,
                mediaRegionalPorUnidade,
                mediaPermitidaPorUnidade,
                mediaTerritorioPorUnidade,
                excedentePorUnidade,
                percentualExcedentePorUnidade
            } = error.response.data.output;

            const medias = [
                {
                    estadoNome,
                    mediaRegionalPorUnidade,
                    mediaPermitidaPorUnidade,
                    mediaTerritorioPorUnidade,
                    excedentePorUnidade,
                    percentualExcedentePorUnidade
                }
            ];

            this.dadosMediaCapacidadeProdutivaRegional = {
                title: error.response.data.title,
                message: error.response.data.message,
                medias,
                ...error.response.data.output
            };

            this.showModalDadosCapacidadeProdutiva = true;
        },

        cadastroTerritorio() {
            this.$refs['formularioCadastroTerritorio'].resetFields();
            this.showModalCadastroTerritorio = true;
        },

        definirVolumeTerritorioCadastrado(territorioCadastrado) {
            this.showModalCadastroTerritorio = false;
            this.territorioCadastrado = territorioCadastrado;
            this.formularioCadastroTerritorio.territorioSelecionado =
                territorioCadastrado.idTerritorio;

            setTimeout(() => (this.showModalDadosCadastroManual = true), 500);
        },
        definirVolume(volume) {
            this.formularioCadastroTerritorio.volumeTerritorio = volume;
            this.showModalDadosCadastroManual = false;
            this.adicionarTerritorioManual();
        },
        verificarCar(valor) {
            return CarUtils.isCar(valor);
        },
        limparTerritorios() {
            this.territorios = [];
            this.formularioCadastroTerritorio.territorioSelecionado = '';
            this.limparDadosResumo();
        },
        limparCPF() {
            this.formularioCadastroTerritorio.cpfCnpj = '';
            this.limparDadosResumo();
        },
        volumeRecebidoFormatado() {
            this.formularioCadastroTerritorio.volumeTerritorio =
                formatters.formatarTonelada(
                    this.formularioCadastroTerritorio.volumeTerritorio
                );
        },
        validarTerritorioResumo() {
            this.$refs['formularioCadastroTerritorio'].validate(valid => {
                if (valid) {
                    this.realizarResumo();
                } else {
                    return false;
                }
            });
        },
        async realizarResumo() {
            try {
                this.limparDadosResumo();

                const dados = {
                    codigoCar: this.formularioCadastroTerritorio
                        .territorioSelecionado?.codigoCar
                        ? this.formularioCadastroTerritorio
                            .territorioSelecionado.codigoCar
                        : this.formularioCadastroTerritorio
                            .territorioSelecionado,
                    idTerritorio: this.formularioCadastroTerritorio
                        .territorioSelecionado?.idTerritorio
                        ? this.formularioCadastroTerritorio
                            .territorioSelecionado.idTerritorio
                        : 0,
                    cpfCnpj: this.formularioCadastroTerritorio.cpfCnpj,
                    numeroContrato: this.numeroContrato
                };

                this.showResumoElegibilidade = true;

                this.loadingResumo = true;

                const resumo =
                    await ContratoOriginacaoServiceSubEmpresa.buscarResumoAnaliseElegibilidadePreInsercaoTerritorio(
                        dados
                    );

                this.dadosAnaliseElegibilidade.dadosBuscaSaldo =
                    resumo.data.saldoCar;
                this.resultadoElegibilidade =
                    resumo.data.resultadoResumoAnaliseElegibilidadePreInsercaoTerritorioSubempresa;
                this.dadosAnaliseElegibilidade.dadosDiagnostico =
                    resumo.data.diagnosticoSocioambiental;
                this.dadosAnaliseElegibilidade.dadosCalculoRaio =
                    resumo.data.raioCar;
                this.dadosAnaliseElegibilidade.dadosRestricaoEstado =
                    resumo.data.estadoCar;
                this.dadosAnaliseElegibilidade.dadosRestricaoMunicipio =
                    resumo.data.municipioCar;
                this.dadosAnaliseElegibilidade.elegibilidade =
                    this.resultadoElegibilidade;
            } catch (e) {
                this.$notify.error({
                    message: e.response.data.message
                });
            } finally {
                this.loadingResumo = false;
            }
        },
        modalAnaliseElegibilidade() {
            if (this.loadingResumo) {
                return;
            }
            this.dadosAnaliseElegibilidade.safraNome = this.dados.safraNome;
            this.ativarModalAnaliseElegibilidade = true;
        },
        limparDadosResumo() {
            this.showResumoElegibilidade = false;
            this.dadosAnaliseElegibilidade = {
                valor: '',
                dadosDiagnostico: {
                    diagnosticoRepresentante: [],
                    diagnosticoCar: null,
                    resultadoDiagnosticoRastreabilidade: null,
                    nivelAlertaRastreabilidade: null
                },
                dadosCalculoRaio: {
                    distanciaRaioMunicipioECar: null,
                    possuiIntersecao: null,
                    siglaEstadoContrato: null
                },
                dadosBuscaSaldo: {
                    id: null,
                    codigoCar: '',
                    capacidadeProdutiva: null,
                    saldoCARcapacidadeProdutiva: null,
                    cultura: {
                        id: null,
                        nome: '',
                        codigo: ''
                    },
                    anoSafra: {
                        id: null,
                        ano: null,
                        tipoSafra: '',
                        descricao: ''
                    },
                    criadoEm: null,
                    saldoCarComprometido: null
                },
                carregandoBuscarCpfCnpj: false
            };
            this.resultadoElegibilidade = 'INDEFINIDO';
        },

        checkRuleCpfCnpj(rule, value, callback) {
            if (
                !validators.validarDocumento(
                    this.formularioCadastroTerritorio.cpfCnpj
                ) ||
                !this.formularioCadastroTerritorio.cpfCnpj
            ) {
                return callback(new Error('Informe um CPF/CNPJ válido'));
            }
            callback();
        },

        checkRuleCAR(rule, value, callback) {
            let car = value;

            if (value?.codigoCar) {
                car = value.codigoCar;
            }

            if (
                !CarUtils.isCar(car) ||
                !this.formularioCadastroTerritorio.territorioSelecionado
            ) {
                return callback(
                    new Error(
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.carValido'
                        )
                    )
                );
            }

            if (
                this.territorios.length >= 2 &&
                !this.formularioCadastroTerritorio.territorioSelecionado
                    .idTerritorio
            ) {
                return callback(
                    new Error(
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.selecioneTerritorio'
                        )
                    )
                );
            }

            callback();
        },

        adicionarMascaraNaConsulta(consulta) {
            consulta = consulta.replace(/[^\w\s]/gi, '');
            const consultaUpperCase =
                CarUtils.addMascaraCar(consulta).toUpperCase();
            if (consultaUpperCase.length >= 43) {
                return consultaUpperCase.substring(0, 43);
            }
            return consultaUpperCase;
        },

        async buscarRepresentanteNomeOuCpfCnpj(filtro) {
            this.buscandoRepresentante = true;

            if (filtro.length < 3) {
                this.textoBuscandoRepresentante = this.$t(
                    'mensagens.comuns.digiteNoMinimo3CaracteresParaPesquisar'
                );
                this.inputValueRepresentante = '';
                return;
            }
            this.dadosCarsCpfCnp = [];
            this.formularioCadastroTerritorio.cpfCnpj = filtro;

            filtro = filtro.replace(/[^A-Z0-9]/gi, '');

            try {
                this.textoBuscandoRepresentante = 'Carregando...';

                const { data } =
                    await RepresentanteService.buscarPorNomeOuCpfCnpj(filtro);

                this.representantes = data;

                this.inputValueRepresentante = filtro;
            } catch (error) { }
            this.representante = false;
            this.buscandoRepresentante = false;
        },

        async buscarTerritoriosVinculados() {
            this.buscarInforCpfCnpj();
        },

        async buscarInforCpfCnpj() {
            if (
                !this.formularioCadastroTerritorio.cpfCnpj ||
                this.carregandoBuscarCpfCnpj
            ) {
                return;
            }

            let valorCpfCnpjFormatado = this.formatarCpfCnpj(
                this.formularioCadastroTerritorio.cpfCnpj
            );

            if (!this.validaCpfCnpjDigitado(valorCpfCnpjFormatado)) {
                this.$notify.warning({
                    message: 'CPF/CNPJ Inválido.'
                });
                return;
            }

            this.formularioCadastroTerritorio.cpfCnpj = valorCpfCnpjFormatado;
            this.dadosCarsCpfCnp = [];
            this.carregandoBuscarCpfCnpj = true;

            try {
                const cpfCnpj =
                    this.formularioCadastroTerritorio.cpfCnpj.replace(
                        /[^A-Z0-9]/gi,
                        ''
                    );

                try {
                    const { data } =
                        await CarService.buscarCarPorCpfCnpjVinculadoGeral(
                            cpfCnpj
                        );

                    if (data.existemDados) {
                        if (data.carsEstados.length) {
                            data.carsEstados.forEach(carEstado => {
                                carEstado.data.forEach(item => {
                                    const dadoCarSicar = {
                                        codigo: item.codigoCAR,
                                        municipio: item.municipio,
                                        uf: item.uf,
                                        municipioUf: item.municipioUf,
                                        origem: 'SICAR'
                                    };

                                    this.dadosCarsCpfCnp.push(dadoCarSicar);
                                });
                            });
                        }
                        if (data.carsBase.length) {
                            data.carsBase.forEach(item => {
                                const dadoCarBase = {
                                    codigo: item.codigoCAR,
                                    municipio: item.municipio,
                                    uf: item.uf,
                                    municipioUf: item.municipioUf,
                                    origem: 'Mod. Territórios'
                                };

                                this.dadosCarsCpfCnp.push(dadoCarBase);
                            });
                        }

                        if (this.dadosCarsCpfCnp.length) {
                            let dadosCarTratandoRepetidos = [];

                            this.dadosCarsCpfCnp.forEach(item => {
                                const codigoCarDuplicidade =
                                    dadosCarTratandoRepetidos.find(
                                        duplicado =>
                                            duplicado.codigo === item.codigo ||
                                            duplicado.codigo === item.codigoCar
                                    );

                                if (codigoCarDuplicidade !== undefined) {
                                    if (
                                        codigoCarDuplicidade.origem === 'SICAR'
                                    ) {
                                        codigoCarDuplicidade.origem =
                                            'Mod. Territórios / ' +
                                            'SICAR - ' +
                                            codigoCarDuplicidade.uf;
                                    } else {
                                        codigoCarDuplicidade.origem =
                                            'Mod. Territórios / ' +
                                            'SICAR - ' +
                                            item.uf;
                                    }
                                } else {
                                    item.origem =
                                        item.origem === 'SICAR'
                                            ? 'SICAR - ' + item.uf
                                            : 'Mod. Territórios';
                                    dadosCarTratandoRepetidos.push(item);
                                }
                            });

                            this.dadosCarsCpfCnp = dadosCarTratandoRepetidos;

                            this.dadosCarsCpfCnp.sort((a, b) => {
                                const origemA = a.origem.startsWith('SICAR - ')
                                    ? a.origem.slice(8)
                                    : a.origem;
                                const origemB = b.origem.startsWith('SICAR - ')
                                    ? b.origem.slice(8)
                                    : b.origem;
                                return origemA.localeCompare(origemB);
                            });
                        }

                        this.mostrarModalDadosCarsCpfCnp = true;
                    } else {
                        this.alertSemDadosCars();
                    }
                } catch (error) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.erroRequisicao'
                        )
                    });
                }
            } catch (error) { }
            this.carregandoBuscarCpfCnpj = false;
        },

        async exibirDadosCarsCpfCnp(car) {
            if (car === undefined) {
                this.mostrarModalDadosCarsCpfCnp = false;
            } else {
                this.formularioCadastroTerritorio.territorioSelecionado = car;
                this.mostrarModalDadosCarsCpfCnp = false;
                await this.fetchTerritorios(car);
                this.$refs.selectCarTerritorio.focus();
            }
        },
        async exibirDadosTerritorioSelecionado(territorio) {
            if (territorio === undefined) {
                this.mostrarModalDadosTerritorioPy = false;
            } else {
                this.formularioCadastroTerritorio.territorioSelecionado =
                    territorio.padron;
                this.mostrarModalDadosTerritorioPy = false;
                this.$refs.selectCarTerritorio.focus();
            }
        },
        alertSemDadosCars() {
            try {
                this.$messageBox.alert(
                    this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.sistemaNaoIndentificou'
                    ),
                    this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.aviso'
                    ),
                    {
                        confirmButtonText: 'Ok',
                        type: 'info',
                        customClass: 'message-box-infor-sub-empresa-manual'
                    }
                );
            } catch (erro) { }
        },
        alertRepresentanteSemTerritorios() {
            try {
                this.$messageBox.alert(
                    this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.sistemaNaoIndentificou'
                    ),
                    this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.aviso'
                    ),
                    {
                        confirmButtonText: 'Ok',
                        type: 'info',
                        customClass: 'message-box-infor-sub-empresa-manual'
                    }
                );
            } catch (erro) { }
        },
        validaCpfCnpjDigitado(valor) {
            if (valor) {
                return validators.validarDocumento(valor);
            }

            return false;
        },
        formatarCpfCnpj(valor) {
            if (
                /^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(valor) ||
                /^[A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4}-\d{2}$/.test(valor)
            ) {
                return valor;
            } else {
                return formatters.numeralStringFormatTocpfCnpj(
                    valor.replace(/[^A-Z0-9]/gi, '')
                );
            }
        },
        calculaSaldoDisponivel() {
            return (
                this.dadosAnaliseElegibilidade.dadosBuscaSaldo
                    .saldoCARcapacidadeProdutiva -
                this.dadosAnaliseElegibilidade.dadosBuscaSaldo
                    .saldoCarComprometido
            ).toFixed(2);
        }
    }
};
</script>

<style lang="scss">
#bloco-inserir-dados-contrato-originacao-manual {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .obrigatorio::after {
        content: '* ';
        color: red;
        margin-left: 3px;
    }

    .dados-contrato-originacao-manual {
        &__row {
            display: flex;
            gap: 16px;
            width: 100%;
        }

        &__field {
            width: 100%;
            display: flex;
            gap: 3px;
            flex-direction: column;
            justify-content: space-between;
        }

        &__field-label {
            color: $primary;
            font-weight: bold;
        }

        &__input {
            width: 100%;
            height: 40px;
            border-radius: $default-border-radius;
            border: 1px solid $default-border-color;
            outline: 0;
            padding: 0 15px;
        }

        .el-select {
            width: 50%;
        }

    }

    .bloco-dados-contrato-originacao-informacao {
        min-width: 180px;
        width: 100%;

        .informacao-volumes-contrato {
            display: flex;
            gap: 2px;
        }

        .codigo-externo--minificado {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        h4 {
            font-weight: bold;
            font-size: 14px;
            color: var(--primary);
        }

        p.cars-disponivel-label {
            color: #3a9afa;
            font-weight: bold;
            cursor: pointer;
        }

        p.cars-indisponivel-label {
            cursor: not-allowed;
            color: #909399;
        }

        p {
            word-break: break-all;
            max-width: 180px;
        }
    }

    width: 100%;

    h1 {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
    }

    .el-card.is-always-shadow {
        // min-height: 375px;
    }

    el-card {
        margin-top: 10px;
        display: flex;
    }

    .box-card-inserir-dados-manual {
        // height: 333px;

        .width-direito {
            width: 68%;
        }

        .width-esquerdo {
            width: 22%;
        }
    }

    .box-card-inserir-dados-manual__conteudo {
        display: flex;
        flex-direction: column;
        align-content: space-around;
        // min-height: 325px;
        justify-content: space-between;

        .box-card-inserir-dados-manual__conteudo__bloco {
            margin-bottom: 15px;
            font-size: 16px;
            display: flex;
            gap: 15px;

            .box-card-inserir-dados-manual__conteudo__bloco__buttons {
                display: flex;
                justify-content: flex-end;
                gap: 15px;
                margin-top: 39px;

                button.el-button.el-button--primary {
                    width: 100%;
                    height: 40px;
                }
            }

            .box-card-inserir-dados-manual__conteudo__bloco__elegibilidade {
                display: flex;
                flex-direction: column;
                justify-content: center;
                gap: 5px;

                .analise-elegibilidade-span {
                    display: flex;
                    gap: 5px;
                    align-items: center;
                }

                span {
                    font-weight: bold;
                    color: var(--primary);
                    font-size: 14px;
                }

                .status-amarelo {
                    font-weight: bold;
                    color: #bfae19;
                    font-size: 14px;
                    margin-left: 4px;
                }

                .status-laranja {
                    font-weight: bold;
                    color: var(--warning);
                    font-size: 14px;
                    margin-left: 4px;
                }

                .status-danger {
                    font-weight: bold;
                    color: var(--danger);
                    font-size: 14px;
                    margin-left: 4px;
                }

                .status-sucess {
                    font-weight: bold;
                    color: var(--green);
                    font-size: 14px;
                    margin-left: 4px;
                }

                .cabecalho-resumo-elegibilidade {
                    display: flex;
                    gap: 44px;
                    align-items: center;

                    .analise-elegibilidade-codigo-car {
                        font-weight: bold;
                        display: flex;
                        gap: 5px;

                        span.car-codigo {
                            font-weight: normal;
                            color: #303133;
                            font-size: 14px;
                        }
                    }
                }

                .resumo-elegibilidade {
                    display: flex;
                    justify-content: space-between;
                    gap: 5px;
                    align-items: center;
                    flex-wrap: wrap;
                    background-color: #e7e7e7;
                    border-radius: 5px;
                    padding: 8px 8px;
                    min-height: 48px;

                    .resumo-elegibilidade-item {
                        display: flex;
                        gap: 5px;
                        align-items: center;
                        min-height: 30px;
                    }

                    .resumo-elegibilidade__link-detalhar {
                        min-width: 114px;

                        span,
                        i.mdi.mdi-arrow-right {
                            margin-left: 5px;
                            text-decoration: none;
                            color: #1989fa;
                            cursor: pointer;
                        }
                    }

                    .resumo-elegibilidade__link-detalhar:hover {

                        span,
                        i.mdi.mdi-arrow-right {
                            text-decoration: underline;
                        }
                    }

                    .resumo-elegibilidade__saldo--item {
                        min-width: 120px;
                    }

                    .resumo-elegibilidade__diagnostico--item {
                        min-width: 80px;
                    }

                    .resumo-elegibilidade__distancia--item {
                        min-width: 100px;
                    }
                }
            }
        }
    }

    .box-card-inserir-dados-manual__conteudo__bloco_pesquisa {
        flex-direction: row;
        display: flex;
        justify-content: space-between;
        gap: 15px;
        width: 100%;

        .box-card-inserir-dados-manual__conteudo__bloco_pesquisa-por-territorio {
            display: flex;
            flex-direction: column;

            .input-pesquisa-por-territorio {
                display: flex;

                .el-select {
                    width: 100%;
                }

                .el-button {
                    height: 40px;
                    border-radius: 0px 4px 4px 0px;
                }
            }
        }
    }

    .modal-media-capacidade-produtiva {
        .modal-media-capacidade-produtiva__title {
            .el-icon-error {
                margin-right: 5px;
                color: var(--danger);
                font-size: 24px;
            }
        }

        .modal-media-capacidade-produtiva__info {
            margin-right: 5px;
            color: var(--secondary-font-color);
        }

        .modal-media-capacidade-produtiva__label {
            font-weight: bold;
            margin-right: 5px;
            color: var(--primary);
        }

        .modal-media-capacidade-produtiva__excedente {
            color: var(--danger);
            font-weight: bold;
        }

        .modal-media-capacidade-produtiva__permitido {
            color: var(--success);
            font-weight: bold;
        }

        .el-dialog__header {
            display: flex;
            align-items: flex-end;

            span {
                font-size: 18px;
            }
        }

        .el-dialog__body {
            font-size: 14px;
            padding: 20px 20px;
        }

        .modal-media-capacidade-produtiva__linha {
            display: flex;
            justify-content: space-between;
            gap: 30px;
        }

        .modal-media-capacidade-produtiva__coluna {
            width: 100%;
        }
    }

    i.el-tooltip.el-icon-info.dados-manual {
        margin-left: 4px;
    }
}

.input-car-cpf-cnpj {
    .el-input__inner {
        border-radius: 4px 0px 0px 4px !important;
    }
}

.input-car-cpf-cnpj {
    .el-input__inner {
        border-radius: 4px 0px 0px 4px !important;
    }
}

.inserir-dados-manual-sem-resultado {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 5px;
    text-align: center;
    justify-content: center;

    p {
        padding: 0;
        margin-top: 7px;
        margin-bottom: 5px;
    }

    .btn-cadastro {
        border-radius: 20px !important;
        color: #000000;
    }
}

.el-select-dropdown.el-popper>.inserir-dados-manual-sem-resultado-cadastro-car,
.inserir-dados-manual-sem-resultado-cadastro-car+.popper__arrow {
    display: none !important;
    min-width: 0px !important;
}

.message-box-infor-sub-empresa-manual {
    .el-message-box__btns {
        justify-content: end !important;
    }
}

.input-pesquisa-por-territorio-select {
    display: flex;
    gap: 10px;
    justify-content: space-between;

    .direita {
        font-size: 10px;
        color: #8492a6;
    }
}

.input-pesquisa-por-representante-select {
    display: flex;
    gap: 10px;
    justify-content: space-between;

    .direita {
        font-size: 10px;
        color: #8492a6;
    }
}

.notificacao-rastreabilidade {
    width: 470px;
}
</style>
